var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('ul',{staticClass:"menu__list"},_vm._l((_vm.items),function(item){return _c('li',{key:item.href,staticClass:"menu__item"},[_c('a',{class:{
          "menu__link": true,
          "menu__link--is-disabled": item.disabled,
          "menu__link--is-active": _vm.isActive(item.href),
        },attrs:{"href":item.href,"title":item.text,"target":item.target},on:{"click":function($event){return _vm.onClick($event, item)}}},[_vm._v(_vm._s(item.text))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }